import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Arrow from '../../../../assets/images/mannings/arrow-dropdown.png';
import ArrowBlue from '../../../../assets/images/mannings/arrow-down-blue.png';
import ArrowGrey from '../../../../assets/images/mannings/arrow-down-grey.png';
import './Dropdown.scss';

export default class Dropdown extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    input: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    icon: PropTypes.string,
  };

  static defaultProps = {
    onChange: () => {},
    className: '',
    children: <option />,
    input: {},
    value: '',
    disabled: false,
    icon: '',
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const { className, children, input, disabled, value, icon } = this.props;
    return (
      <div className="emmaWrapDiv">
        <select
          className={`emmaAagentSelect ${className}`}
          onChange={this.onChange}
          disabled={disabled}
          value={value}
          {...input}
        >
          {children}
        </select>
        <div onClick={this.onChange}>
          {icon ? (
            <img className="icon" src={icon} alt="" />
          ) : (
            <div className="emma-arrow">
              <img
                className="emmaDrpdwnArrowIcon iconDropdownArrowDark"
                src={Arrow}
                alt="arrow icon"
              />
              <img
                className="emmaDrpdwnArrowIcon iconDropdownArrowBlue"
                src={ArrowBlue}
                alt="arrow icon"
              />
              <img
                className="emmaDrpdwnArrowIcon iconDropdownArrowGrey"
                src={ArrowGrey}
                alt="arrow icon"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
